import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecTooltipTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            tooltip: {
                fontSize: "1rem",
                fontFamily: "EnBW DIN Pro, sans-serif",
                backgroundColor: theme.palette.neutralGray90.main,
                borderRadius: "12px",
            },
            arrow: {
                "&:before": {
                    backgroundColor: theme.palette.neutralGray90.main,
                },
            },
            tooltipPlacementTop: {
                "&.MuiTooltip-tooltipArrow": {
                    marginBottom: "12px !important",
                },
                marginBottom: "6px !important",
            },
            tooltipPlacementRight: {
                "&.MuiTooltip-tooltipArrow": {
                    marginLeft: "12px !important",
                },
                marginLeft: "6px !important",
            },
            tooltipPlacementBottom: {
                "&.MuiTooltip-tooltipArrow": {
                    marginTop: "12px !important",
                },
                marginTop: "6px !important",
            },
            tooltipPlacementLeft: {
                "&.MuiTooltip-tooltipArrow": {
                    marginRight: "12px !important",
                },
                marginRight: "6px !important",
            },
        },
    };
};
